function initStickyAddToCart() {
  const bar = document.querySelector('[data-sticky-atc]');
  if (!bar || bar.__initialized) return;
  bar.__initialized = true;

  const proxyButton = bar.querySelector('[data-sticky-atc-submit]');

  // Show the bar once the real add-to-cart button has scrolled out of view.
  // Also pad the bottom of the page while it's visible so it never covers
  // footer links or policy text permanently.
  const realButton = document.querySelector(
    'product-form button[type="submit"][name="add"]'
  );

  const setVisible = (visible) => {
    bar.classList.toggle('is-visible', visible);
    document.body.classList.toggle('has-sticky-atc', visible);
  };

  if (realButton && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setVisible(!entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(realButton);
  } else {
    // Fallback: always show on mobile if we can't detect the real button.
    setVisible(true);
  }

  if (proxyButton) {
    proxyButton.addEventListener('click', () => {
      const targetButton = document.querySelector(
        'product-form button[type="submit"][name="add"]'
      );
      if (targetButton && !targetButton.disabled) {
        targetButton.click();
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyAddToCart);
} else {
  initStickyAddToCart();
}

document.addEventListener('shopify:section:load', initStickyAddToCart);
